var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usablenet-wrapper",style:({ position: _vm.wrapperPosition })},[_c('a',{staticClass:"UsableNetAssistive",attrs:{"href":"#","onclick":"return enableUsableNetAssistive()"}},[_vm._v(" ENABLE ACCESSIBILITY ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }